<template>
  <div>
    <template v-if="!loading">
      <d-header
        :actions="[{
          label: $t('save'),
          primary: true,
          color: 'is-primary',
          action: submitForm
        }]"
        fluid
        :breadcrumbs="false"
      >
        <h1 class="title">
          <d-previous-btn
            :path="'/properties/' + $route.params.property + '/property-inspections'"
          />
          {{ model.date }}
        </h1>
      </d-header>
      <v-form
        ref="form"
        action="edit"
        :model="model"
        :property-id="propertyId"
      />
    </template>
  </div>
</template>

<script>
import form from "./_form.vue";

export default {
  metaInfo() {
    return {
      title: this.title,
      __property_inspection: this.title // for breadcrumb
    };
  },
  components: {
    "v-form": form
  },
  data () {
    return {
      model: {},
      loading: true,
      propertyId: parseInt(this.$route.params.property)
    };
  },
  computed: {
    title () {
      if (this.model.name) {
        return this.model.name;
      }
      return "";
    }
  },
  watch: {
    "$route.params.propertyInspection" () {
      this.fetch();
    }
  },
  created () {
    this.fetch();
  },
  methods: {
    fetch () {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.property-inspections.show", {
        property: this.propertyId,
        property_inspection: this.$route.params.propertyInspection}
      )
      )
        .then(response => {
          this.loading = false;
          this.model = response.data.data;
        })
        .catch((e) => {
          console.error(e);
          this.$router.push("properties/"+this.propertyId+"/property-inspections");
        });
    },
    submitForm () {
      this.$refs.form.$refs.form.submit();
    }
  }
};
</script>
